<template>
  <div>
    <div class="group">
      <label>Using XPos</label>
      <select v-model="value.usingXPos">
        <option :value="true">{{$t('yes')}}</option>
        <option :value="false">{{$t('no')}}</option>
      </select>
    </div>

    <XPosSettings v-if="value.usingXPos" v-model="value.xPosConfig"/>
  </div>
</template>

<script>
import XPosSettings from "@/components/pos/XPosSettings";

export default {
  name: "IshopPosSettings",
  components: {XPosSettings},
  props: {
    value: Object
  }
}
</script>

<style lang="scss" scoped>

</style>